import { Box, Typography } from '@mui/material'
import { Icon, Image, ImageData, VideoData } from '@media-components'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StyleClassNames } from './styles'

export type TestimonialCardData = {
  name: string
  designation?: string
  location?: string
  imageData?: ImageData
  description: string
  heading?: string
  categories?: string[]
  companyName?: string
  rating?: number
  time?: number
  videoData?: VideoData
  linkedinUrl?: string
}

export type TestimonialCardProps = TestimonialCardData & {
  csx?: CustomStyles<StyleClassNames>
}

export function TestimonialCard({
  imageData = {
    src: '/images/profile-placeholder-temp.png',
    alt: 'profile image',
  },
  name,
  designation,
  location,
  description,
  csx,
}: TestimonialCardProps) {
  const styles = getStyles(defaultStyles, csx)

  return (
    <Box {...styles('wrapper')}>
      <Box {...styles('infoWrapper')}>
        <Image {...imageData} {...styles('image')} />
        <Box {...styles('info')}>
          {/* TODO: define h7 (1.25rem/20px) in typography and assign here */}
          <Typography variant="h6.500">{name}</Typography>
          {designation && (
            <Typography variant="body2.500">{designation}</Typography>
          )}

          {location && (
            <Box {...styles('location')}>
              <Icon
                iconName="Location"
                height={16}
                width={16}
                colorValues="grey.500"
              />
              <Typography variant="body2.400" color="grey.500">
                {location}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Typography>{`"${description}"`}</Typography>
    </Box>
  )
}
